(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["launch-gift-bundle"] && !Shopify.designMode) return;
  try {
    const initializeLaunchGiftTerms = (root = document) => {
    root.querySelectorAll('[data-launch-gift-bundle]').forEach((bundle) => {
      if (bundle.dataset.launchGiftTermsReady === 'true') return;

      const openButton = bundle.querySelector('[data-launch-gift-terms-open]');
      const closeButton = bundle.querySelector('[data-launch-gift-terms-close]');
      const modal = bundle.querySelector('[data-launch-gift-terms-modal]');

      if (!openButton || !closeButton || !modal) return;

      bundle.dataset.launchGiftTermsReady = 'true';

      openButton.addEventListener('click', () => {
        modal.showModal();
      });

      closeButton.addEventListener('click', () => {
        modal.close();
      });

      modal.addEventListener('click', (event) => {
        if (event.target === modal) modal.close();
      });

      modal.addEventListener('close', () => {
        openButton.focus();
      });
    });
  };

  initializeLaunchGiftTerms();
  document.addEventListener('shopify:section:load', (event) => {
    initializeLaunchGiftTerms(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-description-showcase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-description-showcase')) {
    customElements.define(
      'product-description-showcase',
      class ProductDescriptionShowcase extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.content = this.querySelector('[data-product-description-content]');
          this.video = this.querySelector('[data-product-description-video]');
          this.toggle = this.querySelector('[data-product-description-toggle]');
          this.toggleLabel = this.querySelector('[data-product-description-toggle-label]');
          if (!this.content || !this.video || !this.toggle || !this.toggleLabel) return;

          this.moveYouTubeVideos();
          this.toggle.addEventListener('click', () => this.toggleExpanded());
          this.resizeObserver = new ResizeObserver(() => this.measure());
          this.resizeObserver.observe(this.content);
          requestAnimationFrame(() => this.measure());
          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => this.measure());
          }
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        moveYouTubeVideos() {
          const selector = [
            'iframe[src*="youtube.com"]',
            'iframe[src*="youtube-nocookie.com"]',
            'iframe[src*="youtu.be"]'
          ].join(',');
          const frames = Array.from(this.content.querySelectorAll(selector));

          frames.forEach((frame) => {
            const previousParent = frame.parentElement;
            frame.loading = 'lazy';
            if (!frame.title) frame.title = this.dataset.videoTitle || 'YouTube動画';
            if (!frame.allow) {
              frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            }
            frame.allowFullscreen = true;
            this.video.appendChild(frame);

            if (
              previousParent &&
              previousParent !== this.content &&
              previousParent.childElementCount === 0 &&
              previousParent.textContent.trim() === ''
            ) {
              previousParent.remove();
            }
          });

          this.video.hidden = frames.length === 0;
        }

        measure() {
          const collapsedHeight = Number.parseFloat(
            getComputedStyle(this).getPropertyValue('--as-product-description-collapsed-height')
          );
          const canCollapse = Number.isFinite(collapsedHeight) && this.content.scrollHeight > collapsedHeight + 12;

          this.classList.toggle('is-collapsible', canCollapse);
          this.toggle.hidden = !canCollapse;
          if (!canCollapse) this.classList.remove('is-expanded');
          this.updateToggle();
        }

        toggleExpanded() {
          if (
            !this.classList.contains('is-collapsible') ||
            this.classList.contains('is-expanded')
          ) {
            return;
          }
          this.classList.add('is-expanded');
          this.updateToggle();
        }

        updateToggle() {
          const expanded = this.classList.contains('is-expanded');
          this.toggle.setAttribute('aria-expanded', String(expanded));
          this.toggle.hidden = expanded || !this.classList.contains('is-collapsible');
          this.toggleLabel.textContent = this.dataset.expandLabel;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-mobile-nav"] && !Shopify.designMode) return;
  try {
    (function() {
    function initializeProductMobileNav(nav) {
      if (!nav || nav.dataset.mobileNavInitialized === 'true') return;

      var categoryTabRoot = document.querySelector('.as-category-tab');
      if (!categoryTabRoot) return;

      var buttons = Array.prototype.slice.call(
        nav.querySelectorAll('[data-mobile-nav-target]')
      );
      var categoryTabs = Array.prototype.slice.call(
        categoryTabRoot.querySelectorAll('.as-tab-item[data-sections]')
      );

      if (!buttons.length || !categoryTabs.length) return;

      function findCategoryTab(target) {
        return categoryTabs.find(function(tab) {
          return tab.dataset.sections === target;
        });
      }

      var hasAllTargets = buttons.every(function(button) {
        var categoryTab = findCategoryTab(button.dataset.mobileNavTarget);
        var label = button.querySelector('[data-mobile-nav-label]');
        if (!categoryTab || !label) return false;

        var labelText = categoryTab.textContent.trim();
        label.textContent = labelText;
        button.setAttribute('aria-label', labelText);
        return true;
      });

      if (!hasAllTargets) return;

      nav.dataset.mobileNavInitialized = 'true';
      nav.dataset.mobileNavReady = 'true';

      nav.addEventListener('click', function(event) {
        var button = event.target.closest('[data-mobile-nav-target]');
        if (!button || !nav.contains(button)) return;

        var categoryTab = findCategoryTab(button.dataset.mobileNavTarget);
        if (!categoryTab) return;

        categoryTab.click();
      });
    }

    function initializeAllProductMobileNavs() {
      document.querySelectorAll('[data-product-mobile-nav]').forEach(function(nav) {
        initializeProductMobileNav(nav);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAllProductMobileNavs);
    } else {
      initializeAllProductMobileNavs();
    }

    document.addEventListener('shopify:section:load', initializeAllProductMobileNavs);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-shipping-estimate"] && !Shopify.designMode) return;
  try {
    (function() {
    function getToday(timezone) {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: timezone || 'Asia/Tokyo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      var values = {};

      parts.forEach(function(part) {
        if (part.type !== 'literal') values[part.type] = Number(part.value);
      });

      return new Date(Date.UTC(values.year, values.month - 1, values.day, 12));
    }

    function toIsoDate(date) {
      var year = date.getUTCFullYear();
      var month = String(date.getUTCMonth() + 1).padStart(2, '0');
      var day = String(date.getUTCDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    }

    function parseDates(value) {
      var dates = String(value || '').match(/\d{4}-\d{2}-\d{2}/g) || [];
      return new Set(dates);
    }

    function calculateDispatchDate(startDate, businessDays, excludedDates, excludeWeekends) {
      var date = new Date(startDate.getTime());
      var remaining = Math.max(1, Number(businessDays) || 1);

      while (remaining > 0) {
        date.setUTCDate(date.getUTCDate() + 1);
        var weekday = date.getUTCDay();
        var isWeekend = excludeWeekends && (weekday === 0 || weekday === 6);

        if (isWeekend || excludedDates.has(toIsoDate(date))) continue;
        remaining -= 1;
      }

      return date;
    }

    function formatJapaneseDate(date) {
      var weekdays = ['日', '月', '火', '水', '木', '金', '土'];
      return (date.getUTCMonth() + 1) + '月' + date.getUTCDate() + '日（' + weekdays[date.getUTCDay()] + '）';
    }

    function selectedVariantShouldShow(element) {
      var inventoryData = element.querySelector('[data-shipping-estimate-variants]');
      var section = element.closest('section') || document;
      var variantSelect = section.querySelector('.as-product-variant') || document.querySelector('.as-product-variant');
      var variantId = variantSelect ? variantSelect.value : element.dataset.currentVariantId;

      if (!inventoryData || !variantId) return true;

      try {
        var variants = JSON.parse(inventoryData.textContent || '[]');
        var selectedVariant = variants.find(function(variant) {
          return String(variant.id) === String(variantId);
        });
        return !selectedVariant || (
          selectedVariant.in_stock !== false &&
          selectedVariant.requires_shipping !== false
        );
      } catch (error) {
        return true;
      }
    }

    function renderEstimate(element) {
      if (element.dataset.shippingEstimateReady === 'true') return;

      var label = element.querySelector('[data-shipping-estimate-label]');
      if (!label) return;

      try {
        var excludedDates = parseDates(element.dataset.holidays);
        parseDates(element.dataset.specialClosureDates).forEach(function(date) {
          excludedDates.add(date);
        });
        var excludeWeekends = element.dataset.excludeWeekends !== 'false';
        var dispatchDate = calculateDispatchDate(
          getToday(element.dataset.timezone),
          element.dataset.businessDays,
          excludedDates,
          excludeWeekends
        );
        var time = document.createElement('time');

        time.dateTime = toIsoDate(dispatchDate);
        time.textContent = formatJapaneseDate(dispatchDate);
        label.textContent = '';
        label.appendChild(time);
        label.appendChild(document.createTextNode(element.dataset.suffix || 'までに発送予定'));
        element.dataset.shippingEstimateReady = 'true';
      } catch (error) {
        element.dataset.shippingEstimateReady = 'fallback';
      }
    }

    function updateShippingEstimate(element) {
      var shouldShow = selectedVariantShouldShow(element);
      element.hidden = !shouldShow;

      if (shouldShow) renderEstimate(element);
    }

    function initShippingEstimates(root) {
      root.querySelectorAll('[data-shipping-estimate]').forEach(updateShippingEstimate);
    }

    initShippingEstimates(document);
    document.addEventListener('change', function(event) {
      if (!event.target.matches('.as-product-variant')) return;
      initShippingEstimates(event.target.closest('section') || document);
    });
    document.addEventListener('shopify:section:load', function(event) {
      initShippingEstimates(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
